import { render } from "./GradientPicker.vue?vue&type=template&id=f3d0dbae"
import script from "./GradientPicker.vue?vue&type=script&lang=js"
export * from "./GradientPicker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__